import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M7 7h3v10h-3l0 -10","key":"svg-1"}],["path",{"d":"M14 7h3v6h-3l0 -6","key":"svg-2"}]]

const IconBrandTrello = createReactComponent('outline', 'brand-trello', 'BrandTrello', __iconNode);

export default IconBrandTrello;